import { useDispatch, useSelector } from 'react-redux';
import { RadiosIcon } from '@rsos/assets/icons';
import useHasAccessToRadioTranscription from '../../../../hooks/useHasAccessToRadioTranscriptions';
import useHasAccessToUniteEventPane from '../../../../hooks/useHasAccessToUniteEventPane';
import { showRadioPane, hideRadioPane } from '../../EventPane/tabs/radiosSlice';
import { ActionBarItem } from '../ActionBarItem';

const RadiosActionBarItem = () => {
  const dispatch = useDispatch();
  const visible = useSelector(state => state.radios?.visible);

  const hasAccessToRadioTranscription = useHasAccessToRadioTranscription();
  const hasAccessToUniteEventPane = useHasAccessToUniteEventPane();

  const handleClick = () => {
    const toggleRadioPane = visible ? hideRadioPane : showRadioPane;
    dispatch(toggleRadioPane());
  };

  return (
    <ActionBarItem
      iconWidth="18px"
      onClick={handleClick}
      shouldRender={hasAccessToRadioTranscription && hasAccessToUniteEventPane}
      tooltipText=""
      isActive={visible}
      iconDataName="radios-action-bar-item-icon"
    >
      <RadiosIcon />
    </ActionBarItem>
  );
};

export default RadiosActionBarItem;
